import { STRUCTURE_GRID_SIZE } from 'data/constants';
import { EdgeItemType } from 'data/types';
import {
  DOOR_BAR_COLOR,
  getDoorSwingArcPathAlongSpan,
  getWindowTickLinesAlongSpan,
  isGarageDoorWidth,
  usesWindowOpeningVisuals,
  WINDOW_TICK_COLOR,
  WINDOW_TICK_LENGTH_PX
} from 'utils/opening-visuals';

type OpeningDecorationProps = {
  itemType: EdgeItemType['type'];
  lengthPx: number;
  thicknessPx: number;
  inwardSign: 1 | -1;
};

export default function OpeningDecoration({
  itemType,
  lengthPx,
  thicknessPx,
  inwardSign
}: OpeningDecorationProps) {
  const widthFt = lengthPx / STRUCTURE_GRID_SIZE;
  const p1 = { x: 0, y: 0 };
  const p2 = { x: lengthPx, y: 0 };
  const inward = { x: 0, y: inwardSign };

  const showTicks = usesWindowOpeningVisuals(itemType);
  const showArc = itemType === 'door' && !isGarageDoorWidth(widthFt);
  const ticks = showTicks
    ? getWindowTickLinesAlongSpan(p1, p2, inward, WINDOW_TICK_LENGTH_PX)
    : [];
  const arcPath = showArc ? getDoorSwingArcPathAlongSpan(p1, p2, inward) : '';

  if (ticks.length === 0 && !arcPath) {
    return null;
  }

  return (
    <svg
      aria-hidden='true'
      className='pointer-events-none overflow-visible'
      style={{
        position: 'absolute',
        left: 0,
        top: thicknessPx / 2,
        width: 1,
        height: 1,
        overflow: 'visible'
      }}
    >
      {ticks.map((tick) => (
        <line
          key={`${tick.p1.x}-${tick.p1.y}-${tick.p2.x}-${tick.p2.y}`}
          x1={tick.p1.x}
          y1={tick.p1.y}
          x2={tick.p2.x}
          y2={tick.p2.y}
          stroke={WINDOW_TICK_COLOR}
          strokeWidth={1.8}
          strokeLinecap='butt'
        />
      ))}
      {arcPath && (
        <path
          d={arcPath}
          fill='none'
          stroke={DOOR_BAR_COLOR}
          strokeWidth={1.4}
        />
      )}
    </svg>
  );
}
